import { createFileRoute } from '@tanstack/react-router';

import { PersonEditPage } from '@/components/admin/sport/person-edit-page';
import { useAdminEditPageKey } from '@/hooks/use-admin-navigate';
import { adminHead } from '@/lib/seo';
import { personName } from '@/lib/sport/names';
import { adminGetPersonFn } from '@/server/functions/sport';

export const Route = createFileRoute('/_admin/admin/sport/people_/$id')({
    component: PersonEditRoute,
    head: ({ params, loaderData }) => {
        const title =
            params.id === 'new'
                ? 'שחקן חדש'
                : loaderData?.person
                  ? personName(loaderData.person)
                  : 'עריכת שחקן';
        return adminHead(title, `/admin/sport/people/${encodeURIComponent(params.id)}`);
    },
    staleTime: 0,
    preloadStaleTime: 0,
    loader: async ({ params }) => {
        if (params.id === 'new') return null;
        return adminGetPersonFn({ data: { id: params.id } });
    },
});

function PersonEditRoute() {
    const data = Route.useLoaderData();
    const key = useAdminEditPageKey(
        data?.person ? `${data.person.id}:${String(data.person.updatedAt)}` : undefined,
    );
    return <PersonEditPage key={key} data={data} />;
}
